// ChangeSchedulePage.js
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Grid2,
  Paper,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  Tabs,
  Tab
} from '@mui/material';
import {
  Schedule as ScheduleIcon,
  Pause as PauseIcon,
  Refresh as RefreshIcon,
} from '@mui/icons-material';
import CommonWrapper from 'Components/Common/CommonWrapper';
import Drawer from '@mui/material/Drawer';
import CoursePauseDetails from 'Components/CoursePause/CoursePauseDetails';
import CourseResetDetails from 'Components/CourseReset/CourseResetDetails';
import CoursePauseForm from 'Components/CoursePause/CoursePauseForm';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  minHeight: "100vh",
  "& .courseBtn": {
    padding: "16px", 
    position: 'fixed', 
    bottom: 0, 
    width: '100%', 
    zIndex: 1000, 
    display: 'flex',
    justifyContent: 'flex-end',
    // backgroundColor: theme.palette.white.main,
    // boxShadow: '2px 4px 6px 0px rgba(70, 63, 63, 0.75)'
  }
});


// --- Reusable Helper Component for Action Cards ---
const ActionCard = ({ icon, title, description, selected, onClick }) => (
  <Paper
    variant="outlined"
    onClick={onClick}
    sx={(theme) => ({
      p: 2,
      display: 'flex',
      gap: 2,
      alignItems: 'center',
      borderRadius: '8px',
      cursor: 'pointer',
      height: '100%',
      bgcolor: selected ? 'background.default' : 'white.main',
      color: selected ? 'primary.main' : 'secondary.light',
      borderColor: selected ? 'background.default' : 'white.main',
      border: `1px solid ${selected ? theme.palette.primary.main : theme.palette.secondary.light}`,
      transition: 'all 0.2s ease-in-out',
      '& .MuiTypography-h6': {
        color: selected ? 'primary.main' : 'secondary.light',
      },
      '& .MuiTypography-body2': {
        color: selected ? 'primary.main' : 'secondary.light',
      },
      '& .MuiSvgIcon-root': {
        color: selected ? 'primary.main' : 'secondary.light',
      },
    })}
  >
    <Box display={"flex"} flexDirection={"column"} gap="8px">
        <Box display={"flex"} gap="8px">
            {icon}
            <Typography variant="subtitle" fontWeight={700}>{title}</Typography>
        </Box>
      <Typography variant="body2" fontWeight={500}>{description}</Typography>
    </Box>
  </Paper>
);

// --- Main Page Component ---
const ChangeSchedulePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { mainAction, subAction } = useParams();
  const [showDrawer, setShowDrawer] = useState(false);
  // const [mainAction, setMainAction] = useState('schedule-change');
  // const [subAction, setSubAction] = useState('day');





  const handleMainActionChange = (event, newAction) => {
    if (newAction === 'schedule-change') {
      // Reset subAction when mainAction changes
      navigate(`/course/schedule-change/day`);
    } else {
      navigate(`/course/batch/${newAction}`);
    }
  }

  const handleSubActionChange = (event, newAction) => {
    if (newAction !== null) {
      navigate(`/course/${mainAction}/${newAction}`);
    }
  };

  const handleCourseBtnClick = () => {
    if (subAction === 'pause') {
      console.log("Navigating to Course Pause Page");
      setShowDrawer(true);

    } else if (subAction === 'reset') {
      console.log("Navigating to Course Reset Page");
      setShowDrawer(true);

    } else {

    }
  }

  const toggleDrawer = () => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setShowDrawer(false);
  };

  return (
    <>
      <CommonWrapper>
        <Grid2 sx={styles}>
        
        {/* Header */}
        <Typography variant="title" color="secondary.light" fontWeight={700}>Hello Rashid! Need some help with your batch?</Typography>
        {/* <Typography variant="subtitle" color="secondary.light" mb={1}>
            Current batch details: DSML June24 Beginner w/o SQL - Tableau | Tue 09:00 PM | Thu 09:00 PM | Sat 09:00 PM
        </Typography> */}
        <Box display={"flex"} gap="8px">
          <Typography variant="body2" color="secondary.light" fontSize={"14px"} fontWeight={600}>
            Current batch details:
          </Typography>
          <Typography variant="body2" color="secondary.light" fontSize={"14px"} fontWeight={500}>
            DSML June24 Beginner w/o SQL - Tableau | Tue 09:00 PM | Thu 09:00 PM | Sat 09:00 PM
          </Typography>
        </Box>
        

        {/* Main Action Cards */}
        <Grid container spacing={3} mb={4}>
          <Grid item xs={12} sm={2}>
            <ActionCard 
              icon={<ScheduleIcon />} 
              title="Change Schedule" 
              description="Change your day or time schedule as per the available batches" 
              selected={mainAction === 'schedule-change'} 
              // onClick={() => setMainAction('schedule-change')} 
              onClick={(e) => handleMainActionChange(e, 'schedule-change')}
            />
            </Grid>
            <Grid item xs={12} sm={2}>
            <ActionCard 
              icon={<PauseIcon />} 
              title="Pause Course" 
              description="Need a break for any personal or professional reasons?" 
              selected={mainAction === 'batch' && subAction === 'pause'} 
              onClick={(e) => handleMainActionChange(e, 'pause')}
            />
            </Grid>
            <Grid item xs={12} sm={2}>
            <ActionCard 
              icon={<RefreshIcon />} 
              title="Reset Course" 
              description="Want to re-attend lectures from any past date?" 
              selected={mainAction === 'batch' && subAction === 'reset'} 
              onClick={(e) => handleMainActionChange(e, 'reset')}
            />
            </Grid>
        </Grid>

        { mainAction === 'schedule-change' &&
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              // type="filled"
              // type="primary"
              value={subAction}
              // onChange={(e, value) => setSubAction(value)}
              onChange={(e, value) => handleSubActionChange(e, value)}
              >
              <Tab value="day" label="Change Day" />
              <Tab value="time" label="Change Time" />
            </Tabs>
          </Box>
        }

        { mainAction === 'schedule-change' && subAction === "day" ?
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '300px' }}>
              <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400, fontSize: '1rem' }}>
                We're sorry, but no parallel batches are available to change your lecture day
              </Typography>
            </Box> : 
          mainAction === 'schedule-change' && subAction === "time" ?
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '300px' }}>
              <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 400, fontSize: '1rem' }}>
                We're sorry, but no parallel batches are available to change your lecture time
              </Typography>
            </Box> : 
          mainAction === 'batch' && subAction === 'pause' ?
            <CoursePauseDetails /> : 
          mainAction === 'batch' && subAction === 'reset' ?
            <CourseResetDetails /> : <></>
        }

        </Grid2>
      </CommonWrapper>

      { mainAction === 'batch' &&
        <Box 
          sx={(theme) => ({
            // margin: "0 16px",
            padding: "16px 32px", 
            position: 'fixed', 
            bottom: 0, 
            width: '100%', 
            zIndex: 1000, 
            display: 'flex',
            justifyContent: 'flex-end',
            backgroundColor: theme.palette.white.main,
            // boxShadow: '2px 4px 6px 0px rgba(70, 63, 63, 0.75)'
            // boxShadow: '0px -4px 6px 0px rgba(70, 63, 63, 0.75)'
          })}>
          <Button variant='contained' onClick={handleCourseBtnClick}>{subAction === "pause" ? 'Course Pause' : 'Course Reset'}</Button>
        </Box>
      }

      <Drawer
          anchor="bottom"
          open={showDrawer}
          // sx={{ height: "80vh" }}
          PaperProps={{
            sx: {
              height: '90%', // ✅ set custom height here
            },
          }}
          onClose={toggleDrawer()}
        >
          { subAction === 'pause' ?
            <CoursePauseForm toggleDrawer={toggleDrawer} /> :
            subAction === 'reset' ?  
            <CourseResetDetails toggleDrawer={toggleDrawer} /> : <></>
          }
        </Drawer>
    </>
  );
};

export default ChangeSchedulePage;